import React, { useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import QuestionsImg from '../assets/images/connect-agent-cta-icon.svg'
import ContactAgentModal from './ContactAgentModal'
import {ASSETS_URL} from "../api/constants";

function ConnectAgentCTA({ data, loading }) {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <div className="connect-agent-cta common-padding">
        <Container>
          <div className='connect-agent-cta-wrap'>
            <img src={data?.icon ? `${ASSETS_URL}/${data.icon}` : QuestionsImg} alt="" />
            <div className='text-wrap'>
              <h2>{data?.title || "Get help finding an agent"}</h2>
              <p>{data?.subtitle || ""}</p>
            </div>
            <Button
              className="custom-bttn style-3"
              onClick={() => setShowContactModal(true)}
            >
              {data?.btn_link || "Connect with an agent"}
            </Button>
          </div>
        </Container>
      </div>
      <ContactAgentModal show={showContactModal} handleClose={() => setShowContactModal(false)} />
    </>
  );
}
export default ConnectAgentCTA